module.exports = __webpack_public_path__ + "media/country_flags/bg-4e564681.png";